import ComButton from '@/components/ComButton/index.vue'

export const pluginsComp = {
  // 注册
  install (Vue) {
    Vue.component('ComButton', ComButton)
  }
}
